import { render, staticRenderFns } from "./Type-failure.vue?vue&type=template&id=75e8a30e"
import script from "./Type-failure.vue?vue&type=script&lang=ts"
export * from "./Type-failure.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports